"use strict";
if (!String.prototype.endsWith) {
    String.prototype.endsWith = function (search, thisLen) {
        if (thisLen === undefined || thisLen > this.length) {
            thisLen = this.length;
        }
        return this.substring(thisLen - search.length, thisLen) === search;
    };
}



//////////////////
// WEBPACK FOOTER
// ./~/react-dnd/lib/cjs/utils/polyfills/endsWith.js
// module id = 707
// module chunks = 0